import { supabase } from './supabase'
import api from './api'

// Each function tries the backend API first.
// When the backend is unavailable (404/network error), it falls back to a
// direct Supabase query so existing data remains visible.

export async function listTheses(userId) {
  try {
    const { data } = await api.get('/thesis')
    if (!Array.isArray(data)) throw new Error('invalid')
    return data
  } catch {
    if (!userId) return []
    const { data } = await supabase
      .from('theses')
      .select('*, chapters(id, chapter_number, title, word_count, status, sort_order)')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
    return data || []
  }
}

export async function getThesis(id, userId) {
  try {
    const { data } = await api.get(`/thesis/${id}`)
    if (!data?.id || typeof data !== 'object') throw new Error('invalid')
    return data
  } catch {
    if (!userId) return null
    const { data } = await supabase
      .from('theses')
      .select('*, chapters(*)')
      .eq('id', id)
      .eq('user_id', userId)
      .maybeSingle()
    if (data?.chapters) {
      data.chapters.sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
    }
    return data
  }
}

export async function listChapters(thesisId) {
  try {
    const { data } = await api.get(`/thesis/${thesisId}/chapters`)
    if (!Array.isArray(data)) throw new Error('invalid')
    return data
  } catch {
    const { data } = await supabase
      .from('chapters')
      .select('*')
      .eq('thesis_id', thesisId)
      .order('sort_order', { ascending: true })
    return data || []
  }
}
